module.exports = __webpack_public_path__ + "img/responses.403c0acb.svg";